export default "__VITE_ASSET__TGTCjHCt__"